"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskTypePicker = void 0;
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const lab_1 = require("@material-ui/lab");
const useFindTaskTypes_1 = require("../hooks/useFindTaskTypes");
const TaskTypePicker = props => {
    const { value: taskTypeId, filter, options, disabled, errorMessage, textFieldProps, isLoading: isLoadingProp = false, onChange } = props;
    const previousTaskTypeIdRef = (0, react_1.useRef)(taskTypeId);
    const [selected, setSelected] = (0, react_1.useState)();
    const [taskTypes, setTaskTypes] = (0, react_1.useState)([]);
    const { data, isLoading: isFinding, error, findTaskTypes } = (0, useFindTaskTypes_1.useFindTaskTypes)();
    const isLoading = isFinding || isLoadingProp;
    (0, react_1.useEffect)(() => {
        // no fetch if options exist
        !options && findTaskTypes(filter);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [options, findTaskTypes]);
    (0, react_1.useEffect)(() => {
        data && setTaskTypes(data);
    }, [data]);
    (0, react_1.useEffect)(() => {
        options && setTaskTypes(options);
    }, [options]);
    const getTaskType = (0, react_1.useCallback)((id) => {
        return id ? taskTypes.find(taskType => taskType.id === id) : undefined;
    }, [taskTypes]);
    // if taskTypeId changes, reselect entity
    (0, react_1.useEffect)(() => {
        if (previousTaskTypeIdRef.current !== taskTypeId) {
            previousTaskTypeIdRef.current = taskTypeId;
            setSelected(getTaskType(taskTypeId));
        }
    }, [taskTypeId, getTaskType]);
    (0, react_1.useEffect)(() => {
        // if no selected entity yet
        if (selected) {
            return;
        }
        const selectedTaskType = getTaskType(taskTypeId);
        if (selectedTaskType) {
            setSelected(selectedTaskType);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [taskTypeId, getTaskType]);
    return (react_1.default.createElement(lab_1.Autocomplete, { fullWidth: true, loading: isLoading, disabled: disabled, value: selected || null, options: taskTypes, getOptionLabel: option => `${option.label} (${option.prefix})`, getOptionSelected: option => option.id === taskTypeId, onChange: (_, value) => {
            if (value) {
                previousTaskTypeIdRef.current = value.id;
            }
            setSelected(value || undefined);
            onChange === null || onChange === void 0 ? void 0 : onChange(value);
        }, renderInput: params => (react_1.default.createElement(core_1.TextField, Object.assign({}, params, { fullWidth: true, variant: 'outlined', label: 'Select Task Type', placeholder: 'Choose a Task Type', error: !!((error === null || error === void 0 ? void 0 : error.message) || errorMessage), helperText: (error === null || error === void 0 ? void 0 : error.message) || errorMessage }, textFieldProps, { InputProps: Object.assign(Object.assign({}, params.InputProps), textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.InputProps) }))) }));
};
exports.TaskTypePicker = TaskTypePicker;
exports.default = exports.TaskTypePicker;
//# sourceMappingURL=TaskTypePicker.js.map